import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { carousel1 } from "../reusables/carousel1";
import star from "../../assets/images/icons/star.svg";

const HomeHero = () => {
  return (
    <section className="hero dark-bg">
      <div className="section-content-container">
        <div className="hero-slide carousel relative">
          <div className="slider-items-container center-slide-arrows">
            <Slider {...carousel1}>
              <div className="image-container curtain curtain1">
                <p>1</p>
              </div>
              <div className="image-container curtain curtain2">
                <p>2</p>
              </div>
              <div className="image-container curtain curtain3">
                <p>DAN GENERAL TRADING MODERN G+5 APARTMENT</p>
              </div>
              <div className="image-container curtain curtain4">
                <p>4</p>
              </div>
              <div className="image-container curtain curtain5">
                <p>5</p>
              </div>
            </Slider>
          </div>

          <div className="container">
            <div className="large">
              <div className="hero-content-container center centered">
                <div className=" centered-inner">
                  <div className="best-section uppercase">
                    <p className="best-text">NEGASH CONSTRUCTION COMPANY</p>
                    <div className="best-bars-container flex">
                      <div className="best-bar"></div>
                      <img src={star} className="best-star" alt="Star" />
                      <img src={star} className="best-star" alt="Star" />
                      <img src={star} className="best-star" alt="Star" />
                      <img src={star} className="best-star" alt="Star" />
                      <img src={star} className="best-star" alt="Star" />
                      <div className="best-bar"></div>
                    </div>
                  </div>
                  <div className="brand-section best-text-slogan uppercase">
                    <h2 className="best-text">
                      BUILDING YOUR VISION, <br /> CREATING REALITY
                    </h2>
                  </div>
                  <div className="cta-section flex uppercase">
                    <a
                      target="_blank"
                      href="/projects"
                      className="button sub-cta boldTitle white"
                    >
                      Our Portfolio &#8594;
                    </a>
                    <a
                      target="_blank"
                      href="/contact-us"
                      className="button main-cta boldTitle pale-blue-bg dark"
                    >
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
